import styled from 'styled-components';
import { Typography } from '@components/common/Typography';
import { Container as Alert } from '@components/common/Alert/Alert.styles';

/*
====================
Hero Section
====================
 */
export const HeroWrapper = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: space-between;
  > section {
    width: 450px;
  }
  > svg {
    width: 470px;
    aspect-ratio: 1.6;
  }
  padding-bottom: 64px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding-top: 20px;
    padding-bottom: 48px;
    flex-direction: column;
    gap: 32px;
    > section {
      width: 100%;
    }
    > svg {
      width: 360px;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    > svg {
      width: 100%;
    }
  }
  ${Alert} {
    width: 340px;
    max-width: 90%;
  }
`;

export const HeroTitle = styled(Typography)`
  line-height: 47px;
  margin-bottom: 16px;
  width: 40rem;
  display: block;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    width: 35rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    width: 100%;
  }
`;

export const Highlight = styled.span`
  display: inline-block;
  color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: inline;
  }
`;

export const HeroData = styled.div`
  padding: 12px 0 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    width: 440px;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    width: auto;
    gap: 32px;
  }
`;

export const DataItem = styled.div`
align-self: flex-end;
padding: 0 24px 24px 0;
@media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
  padding-bottom: 0;
}
@media (max-width: ${({ theme }) => theme.breakPoints.md}) {
  :first-child {
    width: auto
  }
}
> strong, > b {
    font-size: 24px;
    display: block;
    color: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
    font-family: ${({
      theme: {
        fonts: { spaceGrotesk },
      },
    }) => spaceGrotesk};
    line-height: 1;
    font-weight: 700;
}
> strong {
    font-size: 36px;
}
label {
    font-size: 16px;
    display: block;
    padding-top: 8px;
    color: ${({
      theme: {
        colors: {
          functional: { darkGray },
        },
      },
    }) => darkGray};
`;
